<form [formGroup]="form">
  <div
    formArrayName="pages"
    class="page"
    *ngFor="let page of form.get('pages')['controls']; let i = index;let first=first;">
    <label [formGroupName]="i" class="input-error">
      <input
        ccInput
        formControlName="page"
        [placeholder]="'LEAD_GENERATION.DISPLAY_CONDITIONS.EXAMPLE_PLACEHOLDER' | translate"/>
      <cc-input-errors
        [form]="page"
        inputName="page"
        [errors]="[{'required': 'LEAD_GENERATION.ENTER_URL'}, {'pattern': 'LEAD_GENERATION.ENTER_URL'}]"></cc-input-errors>
    </label>
    <div class="page-then-text" [hidden]="i === 0" translate>LEAD_GENERATION.SETTINGS.THEN</div>
    <div
      class="removalIcon"
      *ngIf="showRemovalIcon">
      <i
        class="material-icons pointer"
        (click)="removePage(i)">delete</i>
    </div>
  </div>
  <a class="link pull-left l-h-1x" (click)="addPage()" translate>LEAD_GENERATION.SETTINGS.ADD_NEXT_PAGE</a>
</form>
